<template>
  <div class="vhp-list-card">
    <div class="vhp-card-wrap" @click="onClickCard(content)">
      <div
        class="vhp-card-background"
        :style="{ backgroundColor: backgroundColor }"
      ></div>

      <div
        v-if="imageLeft"
        class="vhp-card-image mr-16"
        data-aos-duration="800"
        data-aos="fade-right"
      >
        <img
          alt="card-image"
          :src="content.image || ''"
          cover
          @error="replaceImage"
        />
      </div>

      <div class="vhp-card-content-wrap">
        <div
          class="vhp-card-content"
          :class="!imageLeft ? 'right' : ''"
          data-aos-duration="800"
          data-aos="fade-up"
        >
          <strong class="vhp-card-content-title">{{ content.title }}</strong>
          <p class="vhp-card-content-subtitle" v-text="content.subtitle"></p>

          <div class="vhp-card-content-tags" v-if="content.hashTags">
            <span
              v-for="tag in content.hashTags.slice(0, 5)"
              :key="'hashtag-' + tag"
              class="tag"
            >
              # {{ tag }}
            </span>
            <span v-if="content.hashTags.length > 5"> .. </span>
          </div>
        </div>
      </div>

      <div
        v-if="!imageLeft"
        class="vhp-card-image ml-16"
        data-aos-duration="800"
        data-aos="fade-left"
      >
        <img
          alt="card-image"
          :src="content.image || ''"
          cover
          @error="replaceImage"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    content: {
      type: Object,
      default: () => {
        return null;
      },
    },
    baseUrl: {
      type: String,
      default: "/",
    },
    listUrl: {
      type: String,
      default: "/",
    },
    backgroundColor: {
      type: String,
      default: "",
    },
    imageLeft: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {
    onClickCard(content) {
      if (!content.id) {
        this.$router.push("/preparation");
      } else if (content.isExternalLink) {
        window.open(content.externalUrl);
      } else {
        this.$router.push(
          this.baseUrl + "?id=" + content.id + "&list=" + this.listUrl
        );
      }
    },

    getCategoryImage(category) {
      return "@/assets/image/category/" + category.toLowerCase() + ".svg";
    },

    replaceImage(e) {
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");
      const container = document.getElementsByClassName("vhp-card-image")[0];

      canvas.width = container.clientWidth;
      canvas.height = 280;

      ctx.font =
        "32px bold Apple SD Gothic Neo, Pretendard-Regular, NotoSansKR, sans-serif ";
      ctx.textBaseline = "middle";
      ctx.textAlign = "center";
      ctx.fillStyle = "#C4182890";
      ctx.fillRect(0, 0, container.clientWidth, 280);

      ctx.fillStyle = "#C4182830";
      ctx.beginPath();
      ctx.moveTo(container.clientWidth * 0.6, 0);
      ctx.lineTo(container.clientWidth, 0);
      ctx.lineTo(container.clientWidth, 200);
      ctx.fill();

      ctx.fillStyle = "#C4182860";
      ctx.beginPath();
      ctx.moveTo(container.clientWidth * 0.6, 280);
      ctx.lineTo(container.clientWidth, 280);
      ctx.lineTo(container.clientWidth, 140);
      ctx.fill();

      ctx.fillStyle = "#FFFFFF";
      ctx.fillText(this.content.title, container.clientWidth / 2, 140);
      let src = canvas.toDataURL("image/png", 1.0);
      e.target.src = src;
    },
  },
};
</script>

<style lang="scss" scoped src="./vhpListCard.scss"></style>
